namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeRow {
        Id?: number;
        DiscCouponType?: string;
        DiscCouponName?: string;
        DiscCouponValueType?: DiscCouponValueType;
        DiscCouponValue?: number;
        PartnerCompensatePc?: number;
        ProdImageLink?: string;
        ItemOrBillFg?: number;
        StartDate?: string;
        EndDate?: string;
        DayFg?: number;
        PromoDay?: number[];
        ShopFg?: number;
        PromoShop?: string[];
        CustFg?: number;
        PromoMb?: string[];
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsDiscCouponTypeRow {
        export const idProperty = 'DiscCouponType';
        export const nameProperty = 'DiscCouponName';
        export const localTextPrefix = 'InitialData.PsDiscCouponType';
        export const lookupKey = 'InitialData.PsDiscCouponType';

        export function getLookup(): Q.Lookup<PsDiscCouponTypeRow> {
            return Q.getLookup<PsDiscCouponTypeRow>('InitialData.PsDiscCouponType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองส่วนลด:Modify';

        export declare const enum Fields {
            Id = "Id",
            DiscCouponType = "DiscCouponType",
            DiscCouponName = "DiscCouponName",
            DiscCouponValueType = "DiscCouponValueType",
            DiscCouponValue = "DiscCouponValue",
            PartnerCompensatePc = "PartnerCompensatePc",
            ProdImageLink = "ProdImageLink",
            ItemOrBillFg = "ItemOrBillFg",
            StartDate = "StartDate",
            EndDate = "EndDate",
            DayFg = "DayFg",
            PromoDay = "PromoDay",
            ShopFg = "ShopFg",
            PromoShop = "PromoShop",
            CustFg = "CustFg",
            PromoMb = "PromoMb",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
